import {dashboardConstants} from "../../constants/Content/dashboard.constants";

const initialState = {
    property_dashboard   : '',
    left_drawer   : '',
    amenities   : '',
    facility   : '',
    general   : '',
    places   : '',
    photos   : '',
    dashboard: '',
    room   : '',
    isFetching: false,
    error: false
};

export default function (state = initialState, action) {
    switch (action.type) {
        case dashboardConstants.GET_DASHBOARD_REQUEST:
            return {
                ...state,
                error      : false,
                payload    : action.response
            };
        case dashboardConstants.GET_DASHBOARD_SUCCESS:
            return {
                ...state,
                property_dashboard: action.property_dashboard,
                left_drawer: action.left_drawer,
                amenities: action.amenities,
                facility: action.facility,
                general: action.general,
                photos: action.photos,
                room: action.room,
                places: action.places,
                error: false,
                payload: action.response
            };
        case dashboardConstants.GET_DASHBOARD_FAILURE:
            // `return {}` alanlari undefined biraktigi icin Dashboard cokuyordu
            // (leftDrawer.total_vote, dashboard.title gibi korumasiz erisimler var).
            // initialState ile alanlar '' olarak geri geliyor — bu, veri gelmeden
            // onceki ilk render'in aynisi, yani bilesenin zaten isledigi durum.
            return { ...initialState, error: true };
        default:
            return state
    }
}
